import React from "react";
import { getConfig } from "../../hooks/use-config";

import "./styles.css";

const Notification = ({
  type,
  message,
  image = true,
  className,
  textMessage = false,
  icon,
}) => {
  const error = !textMessage ? getConfig(message) : message;
  return (
    <div
      className={`notification-content notification-${type} ${className || ""}`}
    >
      {image && type !== "info" && (
        <img src={icon || `/assets/icons/${type}.svg`} alt={type} />
      )}
      {error || message}
    </div>
  );
};

export default Notification;
